module.exports = __webpack_public_path__ + "img/img.4a7c68f6.png";